import { athenaApi } from './athenaApi';

/**
 * All 7 notification type keys supported by the backend.
 */
export type NotificationType =
  | 'internal_review'
  | 'federal_review'
  | 'approval_complete'
  | 'new_project'
  | 'financial_plan_created'
  | 'financial_plan_updated'
  | 'ims_upload';

export const ALL_NOTIFICATION_TYPES: NotificationType[] = [
  'internal_review',
  'federal_review',
  'approval_complete',
  'new_project',
  'financial_plan_created',
  'financial_plan_updated',
  'ims_upload',
];

export interface NotificationPreference {
  notificationType: NotificationType;
  enabled: boolean;
  label: string;
  description: string;
}

export interface NotificationPreferencesResponse {
  preferences: NotificationPreference[];
}

export interface UpdateNotificationPreferencesRequest {
  preferences: Array<{
    notificationType: NotificationType;
    enabled: boolean;
  }>;
}

const notificationPreferencesApi = athenaApi.injectEndpoints({
  endpoints: (build) => ({
    getMyNotificationPreferences: build.query<NotificationPreferencesResponse, void>({
      query: () => ({ url: 'api/users/me/notification-preferences' }),
      providesTags: ['NotificationPreferences'],
    }),
    updateMyNotificationPreferences: build.mutation<{ message: string }, UpdateNotificationPreferencesRequest>({
      query: (body) => ({
        url: 'api/users/me/notification-preferences',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['NotificationPreferences'],
    }),
  }),
});

export const {
  useGetMyNotificationPreferencesQuery,
  useUpdateMyNotificationPreferencesMutation,
} = notificationPreferencesApi;
